import { createAction, props } from '@ngrx/store'
import { ContactPaymentDataDto, SubjectContactResponseDto } from '../../../../api/backend'
import { ICreatedRepresentative, IReverseProperties } from './show.reducer'
import { ContractTaskEnum } from '../../../../shared/enums/contract-task.enum'

export const SOURCE = '[Subject Show]'

export const resetState = createAction(
    `${SOURCE} ResetState`,
)

export const setSubjectId = createAction(
    `${SOURCE} SetSubjectId`, props<{ subjectId: number }>()
)

// SetSubjectContact has side effects
export const setSubjectContact = createAction(
    `${SOURCE} SetSubjectContact`, props<{ contact: SubjectContactResponseDto; updateOwner?: boolean; updateTenant?: boolean; isOwnerRepresentative?: boolean; isTenantRepresentative?: boolean; task?: ContractTaskEnum }>()
)

export const setSubjectContactProperty = createAction(
    `${SOURCE} SetSubjectContactProperty`, props<{ property: string; value: any }>()
)

export const setOriginalSubject = createAction(
    `${SOURCE} SetOriginalSubject`, props<{ subject: SubjectContactResponseDto }>()
)

export const setActualSubject = createAction(
    `${SOURCE} SetActualSubject`, props<{ subject: SubjectContactResponseDto }>()
)

export const setSubjectContractOwnerParams = createAction(
    `${SOURCE} SetSubjectContractOwnerParams`, props<{ params: any }>()
)

export const setSubjectContractTenantParams = createAction(
    `${SOURCE} SetSubjectContractTenantParams`, props<{ params: any }>()
)

export const setOutgoingPayments = createAction(
    `${SOURCE} SetOutgoingPayments`, props<{ payments: any[] }>()
)

export const setIncomingPayments = createAction(
    `${SOURCE} SetIncomingPayments`, props<{ payments: any[] }>()
)

export const setBaseOpsubRoute = createAction(
    `${SOURCE} SetBaseOpsubRoute`, props<{ route: string }>()
)

export const setBaseRoute = createAction(
    `${SOURCE} SetBaseRoute`, props<{ route: string }>()
)
export const setDisplayPostage = createAction(
    `${SOURCE} SetDisplayPostage`, props<{ value: boolean }>()
)
export const setReadOnly = createAction(
    `${SOURCE} SetReadOnly`, props<{ value: boolean }>()
)
export const setReverse = createAction(
    `${SOURCE} SetReverse`, props<{ value: IReverseProperties }>()
)
export const setPredicate = createAction(
    `${SOURCE} SetPredicate`, props<{ value: string }>()
)

export const setSubjectContactPaymentData = createAction(
    `${SOURCE} SetSubjectContactPaymentData`, props<{ data: ContactPaymentDataDto[] }>()
)
export const updateContactPaymentData = createAction(
    `${SOURCE} UpdateContactPaymentData`, props<{ id: number; data: any }>()
)
export const addContactPaymentData = createAction(
    `${SOURCE} AddContactPaymentData`
)
export const deleteContactPaymentData = createAction(
    `${SOURCE} DeleteContactPaymentData`, props<{ id: number }>()
)

export const setSubjectRepresentatives = createAction(
    `${SOURCE} SetSubjectRepresentatives`, props<{ representatives: any[] }>()
)

export const addRepresentative = createAction(
    `${SOURCE} AddRepresentative`
)
export const updateRepresentative = createAction(
    `${SOURCE} UpdateRepresentative`, props<{ index: number; property: string; value: any }>()
)
export const deleteRepresentative = createAction(
    `${SOURCE} DeleteRepresentative`, props<{ id: number }>()
)

export const setIsEditingSubject = createAction(
    `${SOURCE} SetIsEditingSubject`, props<{ value: boolean }>()
)

export const setSubjectCreatedRepresentative = createAction(
    `${SOURCE} SetSubjectCreatedRepresentative`, props<{ representative: ICreatedRepresentative }>()
)
export const resetSubjectCreatedRepresentative = createAction(`${SOURCE} ResetSubjectCreatedRepresentative`)

// ==> Actions used by Effects
export const loadOutgoingPayments = createAction(`${SOURCE} LoadOutgoingPayments`, props<{ subjectId: number; contact: any }>())
export const loadIncomingPayments = createAction(`${SOURCE} LoadIncomingPayments`, props<{ subjectId: number }>())
